export default "__VITE_ASSET__DtXDeyUV__"